require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.8@core-js/library/fn/object/keys.js
// module id = 79
// module chunks = 0